import { SAVE_ATTENDEE_TYPE_DATA, UPDATE_ATTENDEE_TYPE_STATUS } from "./types";
var initialState = {
    attendeeTypeData: undefined,
    attendeeTypeStatus: { isLoading: true },
};
export function attendeeTypeReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SAVE_ATTENDEE_TYPE_DATA:
            return Object.assign({}, state, {
                attendeeTypeData: action.payload,
            });
        case UPDATE_ATTENDEE_TYPE_STATUS:
            return Object.assign({}, state, {
                attendeeTypeStatus: action.payload,
            });
        default:
            return state;
    }
}
